import {CreatedByDto} from '../models/company/integrations.model';

export class TeamMember {
    categories: any[];
    email: string;
    first_name: string;
    groups: any[];
    id: number;
    last_name: string;
    mfa_enabled: boolean;
    persistent_id: number;
    isSupport: boolean;
    position: any;
    created_by: CreatedByDto | null;
    setFromApiModel(apiModel: any): this {
        this.categories = apiModel.categories;
        this.email = apiModel.email;
        this.first_name = apiModel.first_name;
        this.groups = apiModel.groups;
        this.id = apiModel.id;
        this.last_name = apiModel.last_name;
        this.mfa_enabled = apiModel.mfa_enabled;
        this.persistent_id = apiModel.persistent_id;
        this.isSupport = apiModel.email && apiModel.email === 'support@commitly.com';
        this.created_by = apiModel.created_by;
        return this;
    }
}
